import type { BulkApprovalWorkflowResult } from '@risksmart-app/trpc/src/helpers/run-bulk-approval-workflow';
import type { DeleteActionsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteActionsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteActions = createMutationHook({
  name: 'deleteActions',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.action.delete.mutationOptions({ onSuccess }),
  mapInput: (variables: { Ids: string[] }) => ({ Ids: variables.Ids }),
  // RSP-5789 — the bulk gate partitions the batch; any ids that required
  // approval got a CR created server-side — surface those on the CR read
  // feeds immediately.
  refreshChangeRequestFeedsWhen: (result: BulkApprovalWorkflowResult) =>
    result.changeRequestIds.length > 0,
  invalidate: (trpc) => [
    trpc.frontend.action.register.queryKey(),
    trpc.frontend.action.actionById.queryKey(),
  ],
  // BulkApprovalWorkflowResult partitions the batch: `applied` carries the rows
  // actually deleted; gate-required rows come back in `changeRequestIds` with no
  // error thrown. The legacy GraphQL shape only reports the deleted count.
  mapResponse: (result: BulkApprovalWorkflowResult): DeleteActionsMutation => ({
    deleteActionsById: {
      __typename: 'GenericMutationOutput',
      affected_rows: result.applied.length,
    },
  }),
  graphqlDocument: DeleteActionsDocument,
  graphqlVariables: (variables: { Ids: string[] }) => ({ Ids: variables.Ids }),
  evictFields: ['action', 'action_aggregate'],
});
